import { FunctionComponent, ReactNode, useMemo } from "react";

import { useRunSignalSearch } from "../hooks/useRunSignalSearch";
import { SignalScanRequestsContext, useSignalScanRequestsState } from "./SignalScanRequestsContext";

/**
 * Owns "Run signal search" for one tracker table (PREC-3240): which companies were asked for, the
 * one way to start a search (with its cost confirmation), and the dialog. The table's cells and its
 * selection bar both start searches through the context it provides.
 */
export const TrackerSignalSearchScope: FunctionComponent<{
	trackerId: number | undefined;
	children: ReactNode;
}> = ({ trackerId, children }) => {
	const scanRequests = useSignalScanRequestsState(trackerId);
	const { requestSearch, modal } = useRunSignalSearch(scanRequests);
	const value = useMemo(() => ({ ...scanRequests, requestSearch }), [scanRequests, requestSearch]);

	return (
		<SignalScanRequestsContext.Provider value={value}>
			{children}
			{modal}
		</SignalScanRequestsContext.Provider>
	);
};
